import GatewayFilter from 'types/filters/gatewayFilter';
import Gateway from 'types/gateway';
import { PaginationResult } from 'types/paginationResult';
import axios from 'utils/axios';

export default class GatewayService {
    async getGatewaysCount(tenantId: string): Promise<number> {
        try {
            const result = await axios.post<number>(`/GetGatewaysCount`, tenantId);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch gateways count');
        }
    }

    async getGateways(gatewayFilter: GatewayFilter): Promise<PaginationResult<Gateway>> {
        try {
            const body = {
                page: gatewayFilter.page,
                recordsPerPage: gatewayFilter.recordsPerPage,
                searchString: gatewayFilter.searchString,
                orderBy: gatewayFilter.orderBy,
                orderAscending: gatewayFilter.orderAscending
            };
            const result = await axios.post<PaginationResult<Gateway>>(`/GetGateways`, body);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch gateway list');
        }
    }

    async addGateway(gateway: Gateway, tenantId: string): Promise<boolean> {
        try {
            const response = await axios.post(`/AddGateway`, {
                name: gateway.name,
                maintenanceMode: gateway.maintenanceMode,
                tenantId: tenantId
            });
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add gateway');
        }
    }

    async editGateway(gateway: Gateway): Promise<boolean> {
        try {
            const response = await axios.post(`/EditGateway`, gateway);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to edit gateway');
        }
    }

    async deleteGateway(gatewayId: string): Promise<boolean> {
        try {
            const response = await axios.post(`/DeleteGateway`, gatewayId);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to delete gateway');
        }
    }
}
